<template>
	<v-layout row wrap>
		<v-flex d-flex xs1>
			<v-card color="grey lighten-2">
				<v-card-text>
					<div>
						<strong>
							{{index}}
						</strong>
					</div>

				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs7>
			<v-card color="grey lighten-2">
				<v-card-text>
					<b v-if="bold">
						<strong>
							{{text}}
						</strong>
					</b>
					<div v-else>
						<strong>
							{{text}}
						</strong>
					</div>

				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs4 class="amount">
			<v-card color="grey lighten-3">
				<v-card-text>
					<strong>
						{{value}} {{isPercentage ? " %" : " PLN"}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: "costsSummaryRow",
		props: {
			index: {},
			text: {},
			value: {
				default: null,
			},
			isPercentage: {
				defualt: false,
			},
			bold: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style scoped>
	.theme--dark .grey {
		background-color: #1B1B1B !important;
	}

</style>